import ConfirmationAlert from './confirmationAlert'
export default ConfirmationAlert
